import React from 'react';
import { CalendarPlus } from 'lucide-react';

/**
 * Batch Book —— 派单列表里 Released 那些行上的小图标，和 Gate Fee 并排。
 *
 * 为什么只在 released 上出现：放行了、还没约的柜，就是"该去约"的那一批。
 * 这个按钮打开的弹窗会把同码头、同动作的其它 released 柜一起列出来，
 * 勾几只就一次约几只 —— eModal 的向导本来就能一次装 10 只柜，
 * 以前是一只一只点进去约的。
 */
export const BatchBookButton: React.FC<{
  onClick: () => void;
  /** Stop the click from also triggering row-level handlers (open detail, drag). */
  stopPropagation?: boolean;
}> = ({ onClick, stopPropagation }) => (
  <button
    type="button"
    onClick={(e) => {
      if (stopPropagation) e.stopPropagation();
      onClick();
    }}
    title="Book a terminal appointment — pick several containers to book them in one eModal session"
    aria-label="Book terminal appointment"
    className={
      'inline-flex items-center justify-center h-7 w-7 rounded-md border transition-colors '
      + 'border-emerald-200 text-emerald-600 hover:bg-emerald-50 hover:border-emerald-300'
    }
  >
    <CalendarPlus className="w-3.5 h-3.5" />
  </button>
);

export default BatchBookButton;
